/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconKeyboardArrowRightFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconKeyboardArrowRightFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconKeyboardArrowRightFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconKeyboardArrowRightFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-22Symx': alignSelf,'--mt-2-22Symx': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-22Symx': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-22Symx': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-22Symx': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-22Symx': opacity,'--w-10-22Symx': typeof width === 'number' ? `${width}px` : width,'--h-11-22Symx': typeof height === 'number' ? `${height}px` : height,'--a-7-22Symx': isAnimated ? animation : "none",'--sd-8-22Symx': isAnimated ? strokeDashoffset : 0,'--sd-9-22Symx': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconKeyboardArrowRightFilled.SvgPath"
  data-view-path={viewPath}
 d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
 style={{'--f-12-22Symx': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}